import { avatarClasses, Components, Theme } from '../../material';
import { blend } from '../../system';

export const MuiAvatar: Components<Theme>['MuiAvatar'] = {
  defaultProps: {
    variant: 'circular',
  },
  variants: [
    {
      props: { variant: 'circular' },
      style: ({ theme }) => {
        return {
          backgroundColor: blend(
            theme.palette.background.paper,
            theme.palette.secondary.main,
            0.1
          ),
          color: theme.palette.text.primary,
          border: `1px solid ${theme.palette.background.default}`,
        };
      },
    },
    {
      props: { variant: 'outlined' },
      style: ({ theme }) => {
        return {
          backgroundColor: 'transparent',
          color: theme.palette.text.primary,
          border: `1px solid ${blend(theme.palette.background.paper, theme.palette.secondary.main, 0.4)}`,
        };
      },
    },
  ],
};

export const MuiAvatarGroup: Components<Theme>['MuiAvatarGroup'] = {
  styleOverrides: {
    root: {
      [`& .${avatarClasses.root}`]: {
        borderWidth: 1,
      },
    },
  },
};
